import { getPoListThunkAndSlice } from "./poListSlice";

export interface IPoVenue {
	Venue_ID: number;
	Venue_Name: string;
}

export const { thunk: listPoVenues, slice: listPoVenuesSlice } = getPoListThunkAndSlice<IPoVenue>({
	name: "poVenues",
	path: "/api/Purchasing/ListVenues",
	fallbackPath: "/api/Pricing/ListVenues",
});
